import {
  CustomAttributesInfoModel,
  UserEnrollmentContentInfoModel
} from '@/domain/models/content/enrollment/user-enrollment-content-info-model'

export interface UserEnrollmentContentInfo {
  get(id: number, toEnrollment: boolean): Promise<UserEnrollmentContentInfo.Model>
}

export namespace UserEnrollmentContentInfo {
  export type Model = UserEnrollmentContentInfoModel
  export type CustomAttributesModel = CustomAttributesInfoModel
  export const Key = 'user-enrollment-content-info'
}
